<template>
  <div class="care-faq-item-container">
    <div class="question-bar">
      <div class="question-desc">
        {{ questionDesc }}
      </div>
      <q-icon
        class="icon-expand icon-expand-more"
        :class="{'active': isQuestionOpen}"
        name="o_expand_more"
        @click="toggleQuestion" />
    </div>
    <div
      class="answer-container"
      :class="{'active animate__animated animate__fadeIn': isQuestionOpen}">
      <slot name="answer"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'care-faq-item',
  props: {
    questionDesc: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isQuestionOpen: false,
    };
  },
  methods: {
    toggleQuestion() {
      this.isQuestionOpen = !this.isQuestionOpen;
    },
  },
};
</script>
<style lang="sass" scoped>
.care-faq-item-container
  text-align: left
  margin: 36px 0px
  &.last-child
    margin: 36px 0px 0px
  .question-bar
    display: flex
    justify-content: space-between
    margin: 16px 0px
    .question-desc
      width: 90%
      font-size: 20px
      font-weight: 400
      line-height: 1.25
    .icon-expand
      font-size: 32px
      font-weight: 600
      margin-left: 4px
      transform: rotate(0deg)
      transition: transform 0.5s ease-out
      cursor: pointer
      &.active
        transform: rotate(-180deg)
        transition: transform 0.5s ease-in
  .answer-container
    display: none
    width: 100%
    padding-right: 12vw
    font-size: 16px
    line-height: 1.5
    font-weight: 400
    &.active
      display: block

@media screen and (max-width: 768px)
  .care-faq-item-container
    .question-bar
      .question-desc
        width: 95%
        font-size: 20px
    .answer-container
      padding-right: 6vw

@media screen and (max-width: 576px)
  .care-faq-item-container
    margin: 20px 0
    &.last-child
      margin: 20px 0px 0px
    .question-bar
      .question-desc
        font-size: 18px
      .icon-expand
        font-size: 24px
    .answer-container
      font-size: 14px

@media screen and (max-width: 414px)
  .care-faq-item-container
    .question-bar
      .question-desc
        font-size: 16px
        font-weight: 700

</style>
